import { render } from "./ThemePalettesCreate.vue.js?vue&type=template&id=1f4fab64!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettesCreate.vue?vue&type=template&id=1f4fab64"
import script from "./ThemePalettesCreate.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettesCreate.vue?vue&type=script&lang=js"
export * from "./ThemePalettesCreate.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettesCreate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/publication/ThemePalettesCreate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f4fab64"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f4fab64', __exports__)) {
    api.reload('1f4fab64', __exports__)
  }
  
  module.hot.accept("./ThemePalettesCreate.vue.js?vue&type=template&id=1f4fab64!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./ThemePalettesCreate.vue?vue&type=template&id=1f4fab64", () => {
    api.rerender('1f4fab64', render)
  })

}


export default __exports__